import consumer from "./consumer"

const ScriptedVideoChannel = {
  subscribe(configId, handlers = {}) {
    return consumer.subscriptions.create(
      {
        channel: "ScriptedVideoChannel",
        config_id: configId
      },
      {
        connected() {
          if (handlers.onConnected) handlers.onConnected()
        },

        disconnected() {
          if (handlers.onDisconnected) handlers.onDisconnected()
        },

        received(data) {
          switch (data.type) {
            case "script_analysis_update":
              if (handlers.onAnalysisUpdate) handlers.onAnalysisUpdate(data)
              break
            case "auto_generate_progress":
              if (handlers.onAutoGenerateProgress) handlers.onAutoGenerateProgress(data)
              break
            case "auto_generate_pipeline":
              if (handlers.onAutoGeneratePipeline) handlers.onAutoGeneratePipeline(data)
              break
            case "scene_generation_update":
              if (handlers.onSceneGenerationUpdate) handlers.onSceneGenerationUpdate(data)
              break
            case "first_frame_update":
              if (handlers.onFirstFrameUpdate) handlers.onFirstFrameUpdate(data)
              break
            case "narration_update":
              if (handlers.onNarrationUpdate) handlers.onNarrationUpdate(data)
              break
            case "scene_extension_update":
              if (handlers.onSceneExtensionUpdate) handlers.onSceneExtensionUpdate(data)
              break
            case "reference_images_complete":
              if (handlers.onReferenceImagesComplete) handlers.onReferenceImagesComplete(data)
              break
            case "voice_consistency_complete":
            case "voice_consistency_failed":
              if (handlers.onVoiceConsistency) handlers.onVoiceConsistency(data)
              break
            default:
              if (handlers.onUpdate) handlers.onUpdate(data)
          }
        }
      }
    )
  }
}

export default ScriptedVideoChannel
